import grid from "./grid.module.scss";
export const {
  container,
  row,
  col,
  col1,
  col2,
  col3,
  col4,
  col5,
  col6,
  col7,
  col8,
  col9,
  col10,
  col11,
  col12,
  colSm1,
  colSm2,
  colSm3,
  colSm4,
  colSm5,
  colSm6,
  colSm7,
  colSm8,
  colSm9,
  colSm10,
  colSm11,
  colSm12,
  colMd1,
  colMd2,
  colMd3,
  colMd4,
  colMd5,
  colMd6,
  colMd7,
  colMd8,
  colMd9,
  colMd10,
  colMd11,
  colMd12,
  colLg1,
  colLg2,
  colLg3,
  colLg4,
  colLg5,
  colLg6,
  colLg7,
  colLg8,
  colLg9,
  colLg10,
  colLg11,
  colLg12,
  colXl1,
  colXl2,
  colXl3,
  colXl4,
  colXl5,
  colXl6,
  colXl7,
  colXl8,
  colXl9,
  colXl10,
  colXl11,
  colXl12,
} = grid;
